import { ProductOptionInterface } from 'modules/products/types/product-option-interface'
import { useEffect } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { SixDots, TrashIcon } from '@systemeio/ui/icons'
import { FormInput, FieldErrorAndDescription } from '@systemeio/ui'

function Option({
  option,
  changeOptionName,
  changeOptionValue,
  addEmptyOptionValue,
  deleteOption,
  deleteOptionValue,
  error,
  errorOptionValues,
}: {
  option: ProductOptionInterface
  changeOptionName: (e: React.ChangeEvent<HTMLInputElement>) => void
  changeOptionValue: (e: React.ChangeEvent<HTMLInputElement>, optionValueId: string) => void
  addEmptyOptionValue: (option: ProductOptionInterface) => void
  deleteOption: () => void
  deleteOptionValue: (e: React.MouseEvent<SVGSVGElement>, optionValueId: string) => void
  error: string
  errorOptionValues?: string
}) {
  const { t } = useLocoTranslation()

  const handleChangeOptionName = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeOptionName(e)
  }

  useEffect(() => {
    addEmptyOptionValue(option)
  }, [])

  return (
    <div className="my-2">
      <label className="text-sm font-medium">
        <span>{t('dashboard.products.options.option_name.title')}</span>
      </label>
      <div className="flex gap-3">
        <div className="grow">
          <FormInput
            value={option.name}
            placeholder={t('dashboard.products.options.option_name.title')}
            onChange={handleChangeOptionName}
            maxLength={256}
            error={error}
          />
        </div>
        <TrashIcon
          className="hover:fill-danger mt-4 cursor-pointer transition-colors"
          onClick={deleteOption}
        />
      </div>
      <div className="my-2 ml-7 text-sm font-medium">
        {t('dashboard.products.options.option_values.title')}
      </div>
      {option.optionValues.map(optionValue => (
        <div className="my-2 flex items-center gap-3" key={optionValue.id}>
          <SixDots />
          <div className="w-[90%]">
            <FormInput
              value={optionValue.value}
              placeholder={t('dashboard.products.options.add_option_value.title')}
              onChange={e => changeOptionValue(e, optionValue.id)}
              maxLength={256}
            />
          </div>
          {optionValue.value && (
            <TrashIcon
              className="hover:fill-danger mt-0 cursor-pointer transition-colors"
              onClick={e => deleteOptionValue(e, optionValue.id)}
            />
          )}
        </div>
      ))}
      <FieldErrorAndDescription error={errorOptionValues} />
      <hr className="border-text-secondary -ml-6 -mr-6 mb-2 mt-2 border-t-[1.5px] border-solid opacity-40" />
    </div>
  )
}

export default Option
